define([ // START Open Requre.JS wrapper
	'jquery',
	"wcs.context",
	], function($, ctx) {
		
	"use strict";
	
	var referrerTrackingData = null, retainReferrerNewVal,
		pageDomain = document.domain,
		referrerDomain = document.referrer.split('/')[2],
		pageBreadCrumb = $('.breadcrumb-js').data("breadcrumb"),
		pageType = $('body').data("page-type"),
		retainReferrer = ctx.getCookie("referrerTrackingRetain");

	if(referrerDomain !== undefined && referrerDomain != pageDomain){
		referrerTrackingData = "external link";
		retainReferrerNewVal = "false";
	} else if(pageType == "pdp") {
		if(retainReferrer == "true")	//Retain referrer on PDP load
			referrerTrackingData = ctx.getCookie("referrerTracking");
		else referrerTrackingData = pageBreadCrumb;

		retainReferrerNewVal = "false";
	} else if (pageType == "search") {
		referrerTrackingData = "search";
		retainReferrerNewVal = "true";
	} else if (pageType == "wishlist") {
		referrerTrackingData = "wish list";
		retainReferrerNewVal = "true";
	} else if (pageType == "prodlistgrid") {
		referrerTrackingData = pageBreadCrumb;
		retainReferrerNewVal = "true";
	} else {
		referrerTrackingData = pageBreadCrumb;
		retainReferrerNewVal = "false";
	}

	ctx.setCookie("referrerTracking", referrerTrackingData);
	ctx.setCookie("referrerTrackingRetain", retainReferrerNewVal);
}); // Close Require.JS wrapper